import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import ResponsiveModalAbsolute from "../../../components/ResponsiveModalAbsolute";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { ShowDateToUser } from "../../../components/ShowDateToUser";
import { Contactos } from "./Contactos";
import { useAppSelector } from "../../../hooks/hooks";

interface Props {
    contactoSelect: Contactos;
    modalVisible: boolean;
    setContactoSelect: (contactoSelect: Contactos) => void;
    setModalVisible: (b: boolean) => void;
}

interface RegisterForm {
    nombre?: string;
    apellido?: string;
    correo?: string;
}

type errorObject = { [key: string]: string };

interface Interes {
    tipo_alquiler: string;
    tipo_inmueble: string;
}

const ModalContacto = ({
    modalVisible,
    setContactoSelect,
    contactoSelect,
    setModalVisible,
}: Props) => {
    const [errors, setErrors] = useState<RegisterForm>({});
    const [contacto, setContacto] = useState<Contactos>(contactoSelect);
    const [intereses, setIntereses] = useState<Interes[]>([]);
    const { id, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado
    );

    useEffect(() => {
        getIntereses();
    }, [contacto]);

    const getIntereses = async () => {
        const data = await fetchAxiosToken({
            url: `/usuario_intereses/get/${contacto.id}`,
        });

        if (data.intereses) {
            setIntereses(data.intereses);
        } else {
            setIntereses([]);
        }
    };

    const navegar = (id: number, tipo: string) => {
        window.open(
            `/dashboard/${tipo === "pedido" ? "reservas" : "crm"}/${id}`,
            "_blank"
        );
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
        >
            <div className="flex flex-col items-center max-w-lg gap-4 p-4 mx-auto md:p-10">
                <h2 className="text-base font-medium">Detalle de contacto</h2>
                <label className="font-medium ">{contacto.tipo_contacto}</label>
                <div className="w-full text-center ">
                    <div className="flex justify-around gap-2">
                        <div>
                            <label className="ml-1 text-lg font-semibold">
                                Nombre
                            </label>

                            <p className="w-full pt-2 ">{contacto?.nombre}</p>
                        </div>
                        <div>
                            <label className="ml-1 text-lg font-semibold">
                                Apellido
                            </label>

                            <p className="w-full pt-2 ">{contacto?.apellido}</p>
                        </div>
                    </div>
                </div>

                <div className="w-full text-center">
                    <div className="grid grid-cols-2 gap-2">
                        <div>
                            <label className="text-lg font-semibold ">
                                Correo
                            </label>

                            <p className="w-full pt-2 ">{contacto?.correo}</p>
                        </div>
                        <div>
                            <label className="text-lg font-semibold ">
                                Telefono
                            </label>

                            <p className="w-full pt-2 ">{contacto?.celular}</p>
                        </div>
                    </div>
                </div>

                <div className="w-full text-center">
                    <div className="grid grid-cols-2 gap-2">
                        <div>
                            <label className="text-lg font-semibold ">
                                Ultima reserva
                            </label>

                            <div className="flex items-center justify-center pt-2">
                                <ShowDateToUser
                                    date={contacto.fecha_ultima_reserva}
                                />

                                {contacto.fecha_ultima_reserva && (
                                    <svg
                                        onClick={() =>
                                            navegar(
                                                contacto.id_pedido,
                                                "pedido"
                                            )
                                        }
                                        className="w-6 h-6 cursor-pointer text-blue-blueFrom hover:scale-110 "
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                        />
                                    </svg>
                                )}
                            </div>
                        </div>
                        <div>
                            <label className="text-lg font-semibold ">
                                Etapa del CRM
                            </label>

                            <p
                                onClick={() =>
                                    contacto.etapa_crm.length &&
                                    navegar(contacto.id_crm, "crm")
                                }
                                className={` pt-2 ${
                                    contacto.etapa_crm.length &&
                                    "cursor-pointer hover:scale-105"
                                }`}
                            >
                                {contacto.etapa_crm}
                            </p>
                        </div>
                    </div>
                </div>
                {tipo_usuario === 6 && (
                    <div className="w-full max-w-xl mt-6">
                        <label className="font-medium 2xl:text-base text-sm block mb-1">
                            Presupuesto
                        </label>
                        <hr className="w-full border-2 bg-gray-700 mb-4" />

                        <div className="flex flex-row items-start justify-start gap-4 font-semiboldfg">
                            <div className="flex flex-col md:flex-row gap-4">
                                {contacto.presupuesto_inicio} {" - "}{" "}
                                {contacto.presupuesto_final}
                            </div>

                            <div className="">
                                {contacto.tipo_moneda_presupuesto}
                            </div>
                        </div>
                    </div>
                )}

                {intereses.length > 0 && (
                    <div className="mt-6 w-full ">
                        <h3 className="font-semibold text-base mb-2">
                            Intereses agregados:
                        </h3>
                        <div className="w-full text-base">
                            {intereses.map((item, index) => (
                                <div
                                    className="flex justify-between items-center border-b border-gray-300 p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
                                    key={index}
                                >
                                    {item.tipo_alquiler} - {item.tipo_inmueble}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </ResponsiveModalAbsolute>
    );
};

export default ModalContacto;
